var exports = {
  "qd": "FloatingUnreadIndicators.module__layer___dlFKWl",
  "NI": "FloatingUnreadIndicators.module__slot___dlFKWl",
  "AH": "FloatingUnreadIndicators.module__slotTop___dlFKWl",
  "Y0": "FloatingUnreadIndicators.module__slotBottom___dlFKWl",
  "q3": "FloatingUnreadIndicators.module__indicator___dlFKWl",
  "lL": "FloatingUnreadIndicators.module__indicatorBrand___dlFKWl",
  "Gi": "FloatingUnreadIndicators.module__indicatorMention___dlFKWl",
};

module.exports = exports;
